import { useTranslation } from "react-i18next";
import { useState } from "react";
import { getCurrency } from "../../lib/middleware";

export default function PaymentMethod({
    paymentMethods,
    paymentMethod,
    setPaymentMethod,
    total,
}: {
    paymentMethods: string[];
    paymentMethod: string;
    setPaymentMethod: (method: string) => void;
    total: number | null;
}) {
    const { t } = useTranslation();
    const [selectedCardId, setSelectedCardId] = useState<number | null>(null);

    const styles = {
        imageContainer: { display: "flex", alignItems: "center" },
        tabbyContainer: {
            marginRight: 4,
            border: "1px solid #ccc",
            padding: "10px 4px",
            borderRadius: 4,
        },
        image: { width: 48, height: 20 },
    };

    const savedCards: any[] = [
        // { id: 1, label: "•••• 4242" },
        // { id: 2, label: "•••• 1111" },
    ];

    const handleCardChange = (id: number) => {
        setSelectedCardId(id);
        console.log("Selected card:", id);
    };

    const handleAddNewCard = () => {
        setSelectedCardId(0);
        console.log("Trigger Add New Card flow");
    };

    return (
        <div className="flex flex-col gap-4">
            <span className="text-2xl font-medium text-[rgba(38,38,38,1)]">
                {t("payment-method")}
            </span>
            <div className="flex flex-col gap-2 rounded-xl border border-[rgba(229,229,229,1)] bg-white p-4">
                {paymentMethods.map((method, idx) => {
                    const methodStr = String(method);
                    const isSelected = paymentMethod === methodStr;

                    const renderRadio = () => (
                        <input
                            type="radio"
                            name="paymentMethod"
                            checked={isSelected}
                            onChange={() => setPaymentMethod(methodStr)}
                            className="mt-1 h-4 w-4 accent-green-700"
                        />
                    );

                    if (["2", "12", "9"].includes(methodStr)) {
                        return (
                            <div key={idx} className="flex flex-col gap-2">
                                <label className="flex cursor-pointer gap-2 py-3">
                                    {renderRadio()}
                                    <div className="flex flex-1 flex-col items-start gap-3.5">
                                        <span className="leading-none text-[rgba(64,64,64,1)]">
                                            {t("credit-debit-card")}
                                        </span>
                                        <div className="flex flex-wrap gap-2">
                                            <img
                                                className="h-[40px] w-[60px]"
                                                src="/payment/VISA_logo.png"
                                                alt="Visa"
                                            />
                                            <img
                                                className="h-[40px] w-[60px]"
                                                src="/payment/PayPal_logo.png"
                                                alt="PayPal"
                                            />
                                            <img
                                                className="h-[40px] w-[60px]"
                                                src="/payment/mastercard_logo.png"
                                                alt="Mastercard"
                                            />
                                            <img
                                                className="h-[40px] w-[60px]"
                                                src="/payment/GooglePay_logo.png"
                                                alt="GooglePay"
                                            />
                                            <img
                                                className="h-[40px] w-[60px]"
                                                src="/payment/ApplePay_logo.png"
                                                alt="ApplePay"
                                            />
                                        </div>
                                    </div>
                                </label>

                                {/* Saved Cards */}
                                {paymentMethod === "2" && (
                                    <div className="ml-6 flex flex-col gap-2">
                                        {savedCards.map((card) => (
                                            <label
                                                key={card.id}
                                                className="flex cursor-pointer items-center gap-2"
                                            >
                                                <input
                                                    type="radio"
                                                    name="savedCard"
                                                    checked={
                                                        selectedCardId ===
                                                        card.id
                                                    }
                                                    onChange={() =>
                                                        handleCardChange(
                                                            card.id,
                                                        )
                                                    }
                                                    className="accent-green-700"
                                                />
                                                <span className="text-sm">
                                                    {card.label}
                                                </span>
                                            </label>
                                        ))}
                                        <label className="flex cursor-pointer items-center gap-2">
                                            <input
                                                type="radio"
                                                name="savedCard"
                                                checked={selectedCardId === 0}
                                                onChange={handleAddNewCard}
                                                className="accent-green-700"
                                            />
                                            <span className="text-sm text-green-700">
                                                {t("add-new-card")}
                                            </span>
                                        </label>
                                    </div>
                                )}
                                <hr className="border-t-[0.5px] border-[rgba(178,178,178,0.32)]" />
                            </div>
                        );
                    }

                    if (methodStr === "1") {
                        return (
                            <div key={idx}>
                                <label className="flex cursor-pointer gap-2 py-3">
                                    {renderRadio()}
                                    <div className="flex flex-1 flex-col items-start gap-3.5">
                                        <span className="leading-none text-[rgba(64,64,64,1)]">
                                            {t("cash-on-delivery")}
                                        </span>
                                        <div className="flex flex-wrap gap-2">
                                            <img
                                                className="h-[40px] w-[60px]"
                                                src="/payment/CASH_logo.png"
                                                alt="Cash"
                                            />
                                        </div>
                                    </div>
                                </label>
                                <hr className="border-t-[0.5px] border-[rgba(178,178,178,0.32)]" />
                            </div>
                        );
                    }

                    if (methodStr === "6") {
                        return (
                            <div key={idx}>
                                <label className="flex cursor-pointer gap-2 py-3">
                                    {renderRadio()}
                                    <div className="flex flex-1 flex-col items-start gap-3.5">
                                        <span className="leading-none text-[rgba(64,64,64,1)]">
                                            {t("tamara")}
                                        </span>
                                        <div className="flex flex-wrap gap-2">
                                            <img
                                                className="h-[40px] w-[60px]"
                                                src="/payment/Tamara_logo.png"
                                                alt="Tamara"
                                            />
                                        </div>
                                    </div>
                                </label>
                                <hr className="border-t-[0.5px] border-[rgba(178,178,178,0.32)]" />
                            </div>
                        );
                    }

                    if (methodStr === "7") {
                        const cartTotal = total ?? 0;
                        const installment = (cartTotal / 4).toFixed(2);
                        const currency = getCurrency();

                        const getPiePath = (fraction: number) => {
                            const size = 36;
                            const radius = size / 2;
                            const fullCircle = Math.PI * 2;
                            const angle = fullCircle * fraction;
                            const largeArc = fraction > 0.5 ? 1 : 0;
                            const x =
                                radius + radius * Math.cos(angle - Math.PI / 2);
                            const y =
                                radius + radius * Math.sin(angle - Math.PI / 2);
                            return `M${radius},${radius} L${radius},0 A${radius},${radius} 0 ${largeArc},1 ${x},${y} Z`;
                        };

                        return (
                            <div key={idx} className="flex flex-col gap-2">
                                <label className="flex cursor-pointer gap-2 py-3">
                                    {renderRadio()}
                                    <div className="flex flex-1 flex-col items-start gap-3.5">
                                        <span className="text-md text-red-500">
                                            Pay in 4. No interest, no fees
                                        </span>
                                        <div className="flex flex-wrap">
                                            <div style={styles.imageContainer}>
                                                <div
                                                    style={
                                                        styles.tabbyContainer
                                                    }
                                                >
                                                    <img
                                                        src="/payment/tabby.png"
                                                        alt="Tabby"
                                                        style={styles.image}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </label>
                                {isSelected && (
                                    <div className="flex flex-col items-center space-y-3">
                                        <p className="text-gray-700">
                                            Use any card.
                                        </p>
                                        <div className="flex items-center space-x-6">
                                            {[0.25, 0.5, 0.75, 1].map(
                                                (fraction, index) => (
                                                    <div
                                                        key={index}
                                                        className="flex flex-col items-center"
                                                    >
                                                        <svg
                                                            width="50"
                                                            height="50"
                                                            viewBox="0 0 36 36"
                                                        >
                                                            <circle
                                                                cx="18"
                                                                cy="18"
                                                                r="15"
                                                                fill="#D1D5DB"
                                                            />
                                                            <path
                                                                d={getPiePath(
                                                                    fraction,
                                                                )}
                                                                fill="#14B8A6"
                                                            />
                                                        </svg>
                                                        <p className="mt-2 text-lg font-semibold">
                                                            {currency}{" "}
                                                            {installment}
                                                        </p>
                                                        <p className="text-sm text-gray-600">
                                                            {index === 0
                                                                ? "Today"
                                                                : `In ${index} month${index > 1 ? "s" : ""}`}
                                                        </p>
                                                    </div>
                                                ),
                                            )}
                                        </div>
                                    </div>
                                )}
                                <hr className="border-t-[0.5px] border-[rgba(178,178,178,0.32)]" />
                            </div>
                        );
                    }
                    return null;
                })}
            </div>
        </div>
    );
}
